import React, { useState, useEffect } from 'react';
import * as Tone from 'tone';

const INSTRUMENTS = {
  Piano: { baseUrl: '/samples/piano/', notes: ['C4','C#4','D4','D#4','E4','F4','F#4','G4','G#4','A4','A#4','B4'] },
  Sitar:  { baseUrl: '/samples/sitar/',  notes: ['C4','D4','E4','F4','G4','A4','B4'] },
  Harmonium: { baseUrl: '/samples/harmonium/', notes: ['C4','D4','E4','F4','G4','A4','B4'] },
  Tabla:  { baseUrl: '/samples/tabla/', notes: ['Dha','Tin','Na','Te'] }
};

const keyMap = {
  a: 'C4', w: 'C#4', s: 'D4', e: 'D#4', d: 'E4', f: 'F4',
  t: 'F#4', g: 'G4', y: 'G#4', h: 'A4', u: 'A#4', j: 'B4',
  k: 'C5', o: 'C#5', l: 'D5', p: 'D#5', ';': 'E5'
};

const VirtualPiano = () => {
  const [instrument, setInstrument] = useState('Piano');
  const [synth, setSynth] = useState(null);
  const [sustain, setSustain] = useState(false);

  useEffect(() => {
    const { baseUrl, notes } = INSTRUMENTS[instrument];
    const urls = {};
    notes.forEach(n => { urls[n] = `${n}.mp3`; });

    const sampler = new Tone.Sampler({
      urls,
      baseUrl,
      release: sustain ? 4 : 1
    }).toDestination();
    setSynth(sampler);
  }, [instrument, sustain]);

  const play = async note => {
    await Tone.start();
    if (synth) synth.triggerAttackRelease(note, '8n');
  };

  useEffect(() => {
    const down = e => {
      if (e.key === 'Shift') return setSustain(true);
      const note = keyMap[e.key];
      if (note) play(note);
    };
    const up = e => e.key === 'Shift' && setSustain(false);
    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
    };
  }, [synth]);

  return (
    <div style={styles.container}>
      <h2>🎹 Virtual Piano (all instruments)</h2>

      <div style={styles.controls}>
        <label>Instrument:&nbsp;
          <select value={instrument} onChange={e => setInstrument(e.target.value)}>
            {Object.keys(INSTRUMENTS).map(key => (
              <option key={key} value={key}>{key}</option>
            ))}
          </select>
        </label>

        <label style={{ marginLeft: 20 }}>
          <input
            type="checkbox"
            checked={sustain}
            onChange={e => setSustain(e.target.checked)}
          /> Sustain (Shift)
        </label>
      </div>

      <div style={styles.keyboard}>
        {Object.entries(keyMap).map(([keyChar, note]) => {
          const isSharp = note.includes('#');
          return (
            <div
              key={note}
              title={`Press "${keyChar.toUpperCase()}" → ${note}`}
              onClick={() => play(note)}
              style={{
                ...styles.key,
                background: isSharp ? '#333' : '#fff',
                color: isSharp ? '#fff' : '#000',
                width: isSharp ? 40 : 60,
                height: isSharp ? 140 : 220,
                marginLeft: isSharp ? -20 : 0,
                marginRight: isSharp ? -20 : 0,
                zIndex: isSharp ? 2 : 1
              }}
            >
              <div style={styles.keyLabel}>{keyChar.toUpperCase()}</div>
              <div style={styles.noteLabel}>{note}</div>
            </div>
          );
        })}
      </div>

      <p>Click keys or press your keyboard. Use Shift for sustain.</p>
    </div>
  );
};

const styles = {
  container: { textAlign: 'center', fontFamily: 'sans-serif', padding: 20 },
  controls: { marginBottom: 15 },
  keyboard: { display: 'inline-block', position: 'relative' },
  key: {
    position: 'relative',
    border: '1px solid #000',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: 1,
    userSelect: 'none',
    cursor: 'pointer',
  },
  keyLabel: { fontSize: 16, fontWeight: 'bold' },
  noteLabel: { fontSize: 12, color: '#555', marginTop: 6 }
};

export default VirtualPiano;
